module.exports = __webpack_public_path__ + "img/the-herons-court-2.0db36749.png";